import {  createContext, useEffect, useReducer, useState } from "react";
import { toast } from "react-toastify";
import { auth } from "../../Config/Config";
import { client } from "../../utils";
import { browserName, browserVersion } from "react-device-detect";
import  secureLocalStorage  from  "react-secure-storage";
export const UserContext=createContext()
export const loginWith={
   Firebase: 'firebase',
   Microsoft:'microsoft',
   strapi:'strapi'
}
export const userdto={
  uuid:'',
  Token:'',
  homeaddress:'',
  officeaddress:'',address_pkey:'',
  Name:'',Mobile:'',Email:'',Pernr:'',Role:'',
  pobox:'',street:'',cityname:'',Loggedas:'',jobTitle:'',
  companyname:'',region_value:'',SystemMobile:'',CompanyMobile:'',customerid:'',mstoken:''
}
export const userlogdto={
  uuid:'',
  Name:'',Email:'',MobileNo:'',LoggedinTime:'',uuid:'',
  LoginType:'',Browser:'',ComputerDetails:''
}
export const salesaddress={
  street:'',cityname:'',pobox:'',
  officename:'',regioncode:'',fulladdress:'',deliverytype:''
}

export const UserContextProvider=(props)=>{
 const [Userinfo,setUserinfo]=useState(userdto);
 const [userloading,setloading]=useState(false);
 const [userinfoloading,setuserinfoloading]=useState(false);
 const [hrinfoloading,sethrinfoloading]=useState(false);
 const [msprofile,setmsprofile]=useState(false);
 const resetuserinfo=()=>{
     setUserinfo({
      uuid:'',
      Token:'',
      homeaddress:'',
      officeaddress:'',address_pkey:'',
      Name:'',Mobile:'',Email:'',Pernr:'',Role:'',
      pobox:'',street:'',cityname:'',Loggedas:'',jobTitle:'',
      companyname:'',region_value:'',SystemMobile:'',CompanyMobile:'',customerid:'',mstoken:''
    });
 }
 const GetUserInfo= async()=>{
    if (Userinfo.uuid!="")
      {
     setuserinfoloading(true);
     client('/api/address-masters?filters[uuid]=' + Userinfo.uuid ,{}).
      then ((x)=>{
          Userinfo.homeaddress=x.data[0]?.attributes?.homeaddress;
          Userinfo.officeaddress=x.data[0]?.attributes?.officeaddress;
          Userinfo.address_pkey=x.data[0]?.id;
          Userinfo.pobox=x.data[0]?.attributes?.po_box;
          Userinfo.street=x.data[0]?.attributes?.street;
          Userinfo.cityname=x.data[0]?.attributes?.cityname;
          Userinfo.region_value=x.data[0]?.attributes?.region_value;
          setUserinfo(Userinfo);
          setuserinfoloading(false);
         // await GetRole().then((R)=>{
         //   return Userinfo;
         // });
      })
      .catch((z)=>{
           //setloading(false);
           setuserinfoloading(false);
           return null;
      })
    }
  }
 
                                
const [selectedeliveryAddress,setselectedeliveryAddress]=useState(null); 
const [usercontextrefresh,setusercontextrefresh]=useState(false); 
const [salesaddressdto,setsalesaddressdto]=useState(salesaddress); 
const GetRole=async()=>{
 await client('/api/roles-masters?filters[uuid]=' + Userinfo?.uuid,{})
  .then((x)=>{
    Userinfo.Role=x.data[0]?.attributes?.role;
    setUserinfo(Userinfo)
    //setloading(false);
    return Userinfo;
   })
  .catch((y)=>{
    console.log(y);
  })
}
const GetUserProfile=async(mstoken)=>{
 setmsprofile(true);
 await client('https://graph.microsoft.com/v1.0/me',{token:Userinfo.mstoken})
  .then(async(x)=>{
    Userinfo.Mobile=x.mobilePhone;
    Userinfo.jobTitle=x.jobTitle;
    setmsprofile(false);
    sethrinfoloading(true)
    await GetHrDetails(x.mobilePhone)
       .then((data)=>  { 
        //Userinfo.Name=data.resp_sap?.Name;
       // Userinfo.Mobile=data.resp_sap?.Mobile;
       if (data.resp_sap?.Verified==='X')
       {
        Userinfo.Pernr=data.resp_sap?.Pernr;
        Userinfo.companyname=data.resp_sap?.Company;
        Userinfo.CompanyMobile=data.resp_sap?.CompanyMobile;
        Userinfo.SystemMobile=data.resp_sap?.SystemMobile;
        Userinfo.customerid =data.resp_sap?.Customer;
        //Userinfo.Mobile=data.resp_sap?.PersonalMobile; //commented if Login Through O365 then take from o365
       // Userinfo.Email=data.resp_sap?.Email;
       }
        setUserinfo(Userinfo); 
        sethrinfoloading(false) 
        })
       .catch((error)=>{ sethrinfoloading(false)  })
   })
  .catch((y)=>{
    console.log(y);
    setmsprofile(false);
  })
}

function Checksession() {
    //its only for session checking..
    //firebaseloginHandler();
 }

 const [msalInstance,setmsalInstance]=useState(null);
 const loginHandler =async (err, data, msal) => {
  try{
  setloading(true); 
   if (!err && data) {
        //verifying user company is valid for login or eligible..
        const verify= await validateusercompany(data.account.userName,'EM') //Email ID login
        if (verify!='yes'){ 
          setloading(false);
          localStorage.clear();
          secureLocalStorage.clear();
          toast.info('Thank you for your interest.🙂..we will be rolling-out to you soon..',{ autoClose:false,position:"top-center",theme:"colored"});
          return;  
        }
        setmsalInstance(msal);
        var Token =''
        var obj=null
       await client('/api/validate/registeruser',{headers:{auth:data.accessToken,email:data.account.userName,type:'email'}})
       .then(user=>{
           obj=user;
           if (user.error){toast.error(user.error);}
       })
     .catch(nou=>{
       console.log(nou)
       toast.error("Oops!something went wrong!");
        });
       //
        Userinfo.uuid= obj.user.id.toString();
        Userinfo.Token=obj.jwt;
        Userinfo.mstoken=data.accessToken;
        Userinfo.Name =data.account.name;
        Userinfo.Email=data.account.userName;
        Userinfo.Loggedas=loginWith.Microsoft;
        setUserinfo(Userinfo)
        secureLocalStorage.setItem("token",Userinfo.Token)
        secureLocalStorage.setItem("tokentype",Userinfo.Loggedas)
        secureLocalStorage.setItem("uuid",Userinfo.uuid)
        secureLocalStorage.setItem("emailid",Userinfo.Email)
        await GetUserProfile(data.accessToken);
        //await GetUserInfo();
        setloading(false); 
   }
   else {setloading(false);secureLocalStorage.clear();  }
  } catch(ex){
    secureLocalStorage.clear();
   setloading(false); 
   
  }
 };
const strapiloginHandler = async (strapi,mobileno,guid,otp) => {
  try{
   if (secureLocalStorage.getItem('tokentype')===loginWith.strapi || strapi===loginWith.strapi){
     mobileno=secureLocalStorage.getItem('mobileno') || mobileno
     debugger;
     setloading(true); 
     var Token =''
     var obj=null
      sethrinfoloading(true)
      await GetHrDetails(secureLocalStorage.getItem('mobileno'))
       .then(async (data)=>  { 
        if (data.resp_sap?.Verified==='X')//verfying user whether its existing or not..
        {
         //check this company is allowed to purchase products from the portal...
         const verify= await validateusercompany(data.resp_sap?.Company,'MN')  //MN is Mobile Number login
         if (verify!='yes'){ 
           setloading(false);
           localStorage.clear();
           secureLocalStorage.clear();
           toast.info('Thank you for your interest.🙂..we will be rolling-out to you soon..',{ autoClose:false,position:"top-center",theme:"colored"});
           return; 
          }
       await client('/api/validate/registeruser',{headers:{mobile:mobileno,guid:guid,otp:otp,token:secureLocalStorage.getItem("token"),type:'mobileno'}})
       .then(user=>{
           obj=user;
           if (user.error){toast.error(user.error);}
       })
     .catch(nou=>{
       toast.error("Oops!something went wrong!");
        });
        Userinfo.Loggedas=loginWith.strapi;
        Userinfo.uuid= obj.user.id.toString();
        Userinfo.Token=obj.jwt;
        Userinfo.Name=data.resp_sap?.Name;
        Userinfo.Mobile=data.resp_sap?.PersonalMobile;//personel
        Userinfo.Pernr=data.resp_sap?.Pernr;
        Userinfo.Email=data.resp_sap?.Email;
        Userinfo.companyname=data.resp_sap?.Company;
        Userinfo.CompanyMobile=data.resp_sap?.CompanyMobile;
        Userinfo.SystemMobile=data.resp_sap?.SystemMobile;
        Userinfo.customerid =data.resp_sap?.Customer;
        secureLocalStorage.setItem("token",Userinfo.Token);
        secureLocalStorage.setItem("tokentype",loginWith.strapi);
        secureLocalStorage.setItem("uuid",Userinfo.uuid);
        setUserinfo(Userinfo);
        }
        else {
          toast.error('Unable to verify User!Please check with HR')
          secureLocalStorage.clear();
        }  
        sethrinfoloading(false)
        })
       .catch((error)=>{     console.log(error);   })
          setloading(false)
      } 
    }
    catch(ex){
      secureLocalStorage.clear();
      setloading(false); 
    }  
};
const getipaddress = async () =>{
  await client('/ipaddress')
  .then((s)=>{ 
    userlogdto.ComputerDetails= s.clientIp + "," + s.ipAddress;
   })
  .catch((ex)=>{ })
}
 const logoutHandler = () => {
  if (Userinfo.Loggedas===loginWith.strapi){setUserinfo(userdto); secureLocalStorage.clear(); window.location.href='/'  }
  if (Userinfo.Loggedas===loginWith.Microsoft){ setUserinfo(userdto); secureLocalStorage.clear(); msalInstance.logout();}
  if (Userinfo.Loggedas===loginWith.Firebase){
        auth.signOut().then(() => {
           setUserinfo(userdto);
           secureLocalStorage.clear();
           window.location.href='/'
        })
 } 
}
const saveuserlog = async (body)=>{
   try
   {
     client('/api/user-activities',{body:{data:body}})
     .then ((s)=>{
     })
     .catch((error)=>{
       //console.log(error)
     })
   }
   catch(ex)
   {
    console.log(ex)
   }
}
//validating user company and domain name..for the eligibility to purchase product..
const validateusercompany = async (value,logintype)=>{
  if (value==='' ||  value===undefined){ return 'no'; }
  const verified= await client('/api/validate/validateusercompany',{ headers:{ value: value,logintype:logintype } })
  .then(data=>{
      return data.verified;
    })
  .catch(edata=>{
      return edata.verified;
    })
    return verified
    // 
}
const GetHrDetails = async (MobileNo)=>{
    return await client('/api/validate-hr',
    {
    headers: {mobile:'+' + MobileNo,hr:"0"},tokentype:'jwt'})
}
/*const GetHrDetails = async (MobileNo)=>{
  var config = {
    method: 'POST',
    url: process.env.REACT_APP_frontend_api + '/nodeauth/validatelogin',
    data: {mobile:'+' + MobileNo,hr:"0"}
  };
  const response= await axios(config)
  return response.data
}*/
return(
         <UserContext.Provider value={{Userinfo,GetUserInfo,setUserinfo,setselectedeliveryAddress,
             selectedeliveryAddress,userloading,Checksession,msalInstance,loginHandler,logoutHandler,
             GetHrDetails,userinfoloading,hrinfoloading,
             salesaddressdto,setsalesaddressdto,usercontextrefresh,setusercontextrefresh,strapiloginHandler,validateusercompany,resetuserinfo}}>
            {props.children}
        </UserContext.Provider>
    )
}